/**
 * Variáveis dos termos — lista fechada, usada no editor (menu "Inserir variável"), no preview e na
 * geração do PDF. No documento cada uma vira um nó `variable` (chip); na geração, o valor real.
 * Guia: skill `terms-acceptance`.
 */
export const TERM_VARIABLES = [
  { name: 'nome', label: 'Nome do participante', example: 'João da Silva Souza' },
  { name: 'cpf', label: 'CPF do participante', example: '529.982.247-25' },
  { name: 'data_nascimento', label: 'Data de nascimento', example: '10/03/2012' },
  { name: 'evento', label: 'Evento', example: 'Aliste-se Forja Kids' },
  { name: 'data_evento', label: 'Data do evento', example: '09, 10 e 11 Outubro' },
  { name: 'cidade_evento', label: 'Cidade do evento', example: 'Santa Bárbara D´Oeste' },
  { name: 'data_aceite', label: 'Data e hora do aceite', example: '24/09/2026 às 14:32' },
  { name: 'ip', label: 'IP de origem', example: '177.10.20.30' },
  { name: 'versao', label: 'Versão do termo', example: '3' },
  {
    name: 'responsavel_nome',
    label: 'Nome do responsável',
    example: 'Maria da Silva Souza',
  },
  { name: 'responsavel_cpf', label: 'CPF do responsável', example: '111.444.777-35' },
  { name: 'responsavel_parentesco', label: 'Parentesco do responsável', example: 'mãe' },
] as const;

export type TermVariableName = (typeof TERM_VARIABLES)[number]['name'];
export type TermVariableValues = Partial<
  Record<TermVariableName, string | null | undefined>
>;

export const TERM_VARIABLE_NAMES = TERM_VARIABLES.map(
  (v) => v.name,
) as TermVariableName[];

export const termVariableLabel = (name: string) =>
  TERM_VARIABLES.find((v) => v.name === name)?.label ?? name;

/** Valores de exemplo — usados no "Pré-visualizar". */
export const TERM_VARIABLE_EXAMPLES = Object.fromEntries(
  TERM_VARIABLES.map((v) => [v.name, v.example]),
) as Record<TermVariableName, string>;

/** Linha em branco pra preencher à mão quando o valor não existe (nunca "undefined"). */
export const TERM_BLANK = '____________________';

/** Parentesco do responsável (enum `soldier_guardian_relationship`) como sai no termo. */
export const GUARDIAN_RELATIONSHIP_LABELS = {
  father: 'pai',
  mother: 'mãe',
  grandparent: 'avô/avó',
  legal_guardian: 'tutor(a) legal',
  other: 'familiar',
} as const;

export type GuardianRelationship = keyof typeof GUARDIAN_RELATIONSHIP_LABELS;

export const TERM_KIND_LABELS = {
  participation: 'Termo de participação',
  minor_authorization: 'Autorização de menor',
} as const;

export const TERM_STATUS_LABELS = {
  draft: 'Rascunho',
  published: 'Vigente',
  archived: 'Arquivada',
} as const;
